/**
 * Disables verbose console output in production builds so visitor form data
 * (contact and job application submissions) never leaks through the browser
 * console. Warnings and errors are kept so real problems stay visible.
 *
 * Imported first in src/index.tsx.
 */
const noop = (): void => undefined;

if (process.env.NODE_ENV === 'production') {
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.trace = noop;
}

export {};
